import * as _ from "lodash";

const MenuitemModalService = [
    '$modal',
    '$compile',
    '$rootScope',
    '$window',
    '$state',
    'accountService',
    'adviceService',
    'paeService',
    function (
        $modal,
        $compile,
        $rootScope,
        $window,
        $state,
        accountService,
        adviceService,
        paeService
    ) {

        var modalManifest = $rootScope.menuItemModalManifest;

        $rootScope.$on('customizationUpdated', function (event, data) {
            if (typeof modalManifest === 'undefined') {
                modalManifest = data.menuItemModalManifest;
                modalItems = mapModalItems();
            }
        });

        var modalDefaults = {
            showModalOnClick: true
        },
            menuModalInstance, modalScope = $rootScope.$new(),
            modalItems = mapModalItems();

        function mapModalItems() {
            //console.log('modalManifest', modalManifest);
            return _.map(modalManifest, function (modalItem) {
                modalItem = _.assignIn({}, modalDefaults, modalItem);
                modalItem.initModal = function initModal($event) {
                    if (modalItem.showModalOnClick) {

                        modalItem.scope = _.assignIn(modalScope, { originalEvent: $event });
                        openModal();
                    } else {
                        modalScope.navigateOnInit = true;

                        modalScope.modalItem = modalItem;
                        modalScope.openModal = openModal;

                        modalScope.originalEvent = $event
                        modalItem.template = $compile(angular.element(modalItem.template))(modalScope)[0].outerHTML;

                        // not open modal, but continue with event
                        // $window.location.href = $event.target.href;
                    }

                    function openModal() {
                        if (menuModalInstance && _.isFunction(menuModalInstance.close)) {

                            menuModalInstance.close();
                            menuModalInstance = null;
                        }

                        menuModalInstance = $modal.open(modalItem);
                    }
                };
                return modalItem;
            });
        };

        function clickHandler($event, menuItemUrl, fullUrl, fromIframeSubmenu, iFrameUrl, menuItem, subMenuItem) {
            var funcName = 'MenuItemModalService.click : ';
            var modalContent = _.find(modalItems, function (modalObj) {
                console.log("L72");
                console.log(RegExp(modalObj.urlPattern).exec(menuItemUrl));
                return RegExp(modalObj.urlPattern).exec(menuItemUrl);
            });

            if (modalContent && !modalContent.aag) {
                $event.preventDefault();
                modalContent.initModal($event);//trigger a modal
                return true;

            } else
                if (modalContent && modalContent.aag) {
                    $event.preventDefault();

                    //IBBOTSON- MAX/MTR
                    //adviceService data is already preloaded.
                    if (adviceService.ibbotsonEnabled && adviceService.nextGenAdvisoryServicesEnabled) {

                        if (adviceService.alreadyEnrolled) { //Max Dashboard

                            var goToPAEUserError = function () {
                                $state.go("accessDeniedError", { errorCode: "44403" });
                            }

                            var paeCheckSuccess = function (response) {
                                if (response) {
                                    if (response.partnerSSOResponse === false) {
                                        var groupAccount = accountService.getAccountDetails();
                                        sessionStorage.setItem('gId', groupAccount.groupId);
                                        sessionStorage.setItem('indId', groupAccount.individualId);
                                        $window.location.href = '/participant/home/#/max-dashboard';
                                    } else {
                                        console.log('pae users are prohibited from max-dashboard for enrolled ppts');
                                        goToPAEUserError();
                                    }
                                } else {
                                    console.log('unable to verify pae user status', response);
                                    goToPAEUserError();
                                }
                            }

                            var paeCheckFault = function (response) {
                                console.log('failed to perform pae user check.', response);
                                goToPAEUserError();
                            }

                            //determine if the ppt is a pae user...
                            paeService.checkPaeUser().then(paeCheckSuccess, paeCheckFault);

                        } else if (!adviceService.alreadyEnrolled) { //Marketing Page

                            var forcefullUrl = fullUrl.replace("ibbotson-splash", "investment-options/allocations/marketing");
                            // load new page on view
                            $window.location.href = forcefullUrl;
                        }
                        //default
                    }
                    else if (adviceService.feEnabled) {

                        adviceService.navigateFE().then(function () {
                            console.log('succesfully called fe');
                        });
                    }
                    else {

                        modalContent.initModal($event);//trigger a modal
                    }
                }
                else {
                    var isNextGenFeat = subMenuItem && subMenuItem.type === "nextGen";
                    var iframeElem = document.getElementById('legacyFeatureIframe');

                    if (iframeElem && fromIframeSubmenu === true && !isNextGenFeat) {
                        // load inside Iframe
                        iframeElem.src = $window.iframeUrl;
                        return true;

                    } else {
                        // load new page on view
                        $window.location.href = fullUrl;
                        return true;
                    }

                }
        }
        return {
            click: clickHandler
        };
    }
];
export default MenuitemModalService;